<!-- =========================================================================================
     Author: Jose Martin de la Cruz Vicencio
========================================================================================== -->

<template>

    <div id="data-list-list-view" class="data-list-container">
      

        <vs-popup style="" class="holamundo"  title="Documentos Inscripcion:" :active.sync="popupActiveDocumentos2">
            <p>

                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.solicitudInscripcion)">Solicitud Inscripción</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.certificadoBachillerato)">Certificado Bachillerato</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.examenMedico)">Examen Medico</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.cartaConducta)">Carta Conducta</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.comprobanteDomicilio)">Comprobante Domicilio</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.folioSuredsu)">Folio Suredsu</vs-button>
                 <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.codigoEtica)">Codigo Etica</vs-button>

            </p><br>
                 

         <div class="form-group mt-3">
                      <div class="form-check form-switch">
                          <!-- :disabled=""  v-model="formCals.liberadaRegular" -->
                          <input class="form-check-input"  type="checkbox" role="switch" v-model="NoCertificado" id="flexSwitchCheckNoCertificado" />
                                    <!-- class="form-check-label" for="flexSwitchCheck1erParcial" -->
                             <label >No cuenta con certificado de bachillerato, enviar carta compromiso.</label>
                                  
                     </div>
                  </div>
                             

               <p>                            
                <br>
                En caso de rechazar los documentos escriba la razon:
                <vs-input class="" style="width: 100%" placeholder="" v-model="rechazo_documentos2" />
            </p>
            <br>

            <p style="margin: 10px;">
                
                <vs-button :disabled="rechazo_documentos2!='' || NoCertificado!=''" style="margin: 5px" class="float-right"  @click="validar_documentos2(id)">Aprobar</vs-button>
                <vs-button :disabled="rechazo_documentos2=='' && NoCertificado==''" style="margin: 5px" class="float-right" color="warning" @click="rechazar_documentos2(id, rechazo_documentos2,NoCertificado)">Rechazar</vs-button>
            </p>
        </vs-popup>

         
        <vs-table ref="table" pagination :max-items="950" stripe search :data="aspirantes">
            
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <!-- ITEMS PER PAGE -->
            </div>

            <template slot="thead">

                <vs-th>Número</vs-th>
                <vs-th sort-key="id">ID(Ficha)</vs-th>
                <vs-th>Curp</vs-th>
                <vs-th>Correo</vs-th>
                <vs-th>Nombre</vs-th>
                <vs-th>Fecha De Registro</vs-th>
                <vs-th>Fecha De Modificacion</vs-th>
                <vs-th sort-key="sigla">Carrera</vs-th>
                <vs-th sort-key="fecha_examen">Fecha Examen</vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Opciones</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <!-- <vs-tr :state="data[indextr].fecha_examen == 1 ? 'success':data[indextr].fecha_examen == 0 ? 'danger':null" :key="indextr" v-for="(tr, indextr) in data"> -->

                    <vs-td>
                        <p class="product-name font-medium">{{ indextr + 1 }}</p>
                    </vs-td>


                    <vs-td>
                        <p class="product-name font-medium">{{ tr.id }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="product-category">{{ tr.curp }}</p>
                    </vs-td>
                    <vs-td>
                        {{ tr.correo }}
                    </vs-td>
                   <vs-td>
                        <p> {{tr.nombreCandidato}}</p>
                    </vs-td>
                    <vs-td>
                        <p class="product-category">{{ tr.fecha_registro }}</p>
                    </vs-td>
                         <vs-td>
                        <p class="product-category">{{ tr.fecha_modificacion }}</p>
                    </vs-td>

                     <vs-td>
                        <p class="product-category">{{ tr.sigla }}</p>
                    </vs-td>
                    <vs-td>
                        <p class="product-category">{{ tr.fecha_examen }}</p>
                    </vs-td>
                    <vs-td v-if="tr.action == 1">

                        <vs-button @click="cambiar_estatus(tr.statusId, tr.id)" size="small" color="primary" type="gradient">
                        {{tr.statusDescripcion}}</vs-button>

                    </vs-td>
                    <vs-td v-else>

                        <!-- <vs-button size="small" color="primary" type="border">{{tr.statusDescripcion}}</vs-button> -->
                        
                        <vs-button size="small" color="success" type="border">{{tr.statusDescripcion}}</vs-button>


                    </vs-td>

                    <vs-td :data="tr.id">
                        <vs-button size="small" @click="detalles_candidato(tr.id)" color="success" type="gradient">Ver Ficha</vs-button>
                    </vs-td>


                </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>

</template>

<script>
    import vSelect from 'vue-select'
    export default {
        data() {
            return {
                id_rol: this.getKey('id_rol'), 
                id: 0,
                status_actual: 0,
                aspirantes: [],
                // folio_ceneval2:'',
                selected: [],
                users: [],
                itemsPerPage: 500,
                isMounted: false,
                addNewDataSidebar: false,

                popupActiveCeneval:false,
                popupActiveDatos:false,
                popupActiveDocumentos:false,
                popupActivePago:false,
                popupActiveDocumentos2:false,

                folio_ceneval: '',
                rechazo_datos: '',
                rechazo_documentos: '',
                rechazo_documentos2: '',
                NoCertificado:'',
                datos_candidato: '[{}]'

            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx;
                }
                return 0;
            },
        },
        components: {
            'v-select': vSelect
        },
        created() {
          if(this.id_rol == 1 || this.id_rol == 5){
            this.getAspirantes();
            }

        },
        mounted() {
            this.isMounted = true;
        },
        watch: {
            // whenever question changes, this function will run
            status_actual: function(){
               // alert(this.status_actual);
                this.muestra_modal();
            },
        },

        methods: {
            ver_archivo(nombre_archivo){
                window.open('https://cdn.upbicentenario.edu.mx/candidatos_1_2021/' + nombre_archivo);
            },
            cambiar_estatus(status, idc){
                this.status_actual = status;
                this.id = idc;
                // para limpiar los campos al momento de  volver a abrir el popup
                    this.rechazo_documentos2='';
                        this.NoCertificado='';
         

            },
   
            get_datos_candidato(){
                this.$http.get("get_datos_candidatos_aceptados/" + this.id).then(
                    response => {
                        // console.log(response.data)
                        this.datos_candidato = response.data.datos_documentos[0];
                        //console.log(this.kardex);

                    },
                    error => {
                        this.steperror(error);
                    }
                );
            },
            muestra_modal(){

                  if(this.status_actual == 2){
                    this.get_datos_candidato()
                    this.popupActiveDocumentos2 = true;
                    this.status_actual = false;
                    
                }


            },
            detalles_candidato(idficha){
                window.open('https://cdn.upbicentenario.edu.mx/api/pdf_ficha/' + idficha)
            },
            getAspirantes () {
                this.$http.get("ver_documentos_candidatos_aceptados_validar").then(
                    response => {
                        // console.log(response.data)
                        this.aspirantes = response.data.aspirantes_aceptados_validar;
                        //console.log(this.kardex);

                    },
                    error => {
                        this.steperror(error);
                    }
                );
            },

            // validar_datos(id){

            //     this.$http.get("validardatosadmision/" + id).then(
            //         response => {
            //             this.popupActiveDatos = false
            //             this.getAspirantes()
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );


            // },
            // rechazar_datos(id, razon){

            //     this.$http.get("rechazardatosadmision/" + id + '/' + razon).then(
            //         response => {
            //             this.popupActiveDatos = false
            //             this.getAspirantes()
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );


            // },
            // validar_documentos(id){

            //     this.$http.get("validardocumentosadmision/" + id ).then(
            //         response => {
            //             this.popupActiveDocumentos = false
            //             this.getAspirantes()
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );


            // },
            // rechazar_documentos(id, razon){

            //     this.$http.get("rechazardocumentosadmision/" + id + "/" + razon).then(
            //         response => {
            //             this.popupActiveDocumentos = false
            //             this.getAspirantes()
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );


            // },
            validar_documentos2(id){

                this.$http.get("validardocumentosadmisionfinalescandidatosaceptados/" + id).then(
                    response => {
                        this.popupActiveDocumentos2 = false
                        this.getAspirantes()
                    },
                    error => {
                        this.steperror(error);
                    }
                );


            },
            rechazar_documentos2(id, razon,NoCertificado){
                // console.log(NoCertificado);
                if(NoCertificado==''){
                    NoCertificado=0;
                }

                this.$http.get("rechazardocumentosadmisioncandidatosaceptados/" + id + "/" + razon+ "-/" + NoCertificado).then(
                    response => {
                        this.popupActiveDocumentos2 = false
                        this.getAspirantes()
                        this.rechazo_documentos2='';
                        this.NoCertificado='';
                             
                         },
                    error => {
                        this.steperror(error);
                    }
                );


            },

            // validar_pago(id){

            //     this.$http.get("validarpagoadmision/" + id).then(
            //         response => {
            //             this.popupActivePago = false
            //             this.getAspirantes()
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );


            // },

        },
    }
</script>


<style lang="scss" >
    p{

            text-transform: uppercase;
        font-size: 12px !important;

    }
    #data-list-list-view {
        .vs-con-table {

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 12px;
                margin-right: 12px;
                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search{
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 1rem;
                        font-size: 12px;

                        &+i {
                            left: 1rem;
                        }

                        &:focus+i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr{
                    box-shadow: 0 4px 5px 0 rgba(0,0,0,.05);
                    td{
                        padding: 5px;
                        &:first-child{
                            border-top-left-radius: 5px;
                            border-bottom-left-radius: 5px;
                        }
                        &:last-child{
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }
                    td.td-check{
                        padding: 5px !important;
                    }
                }
            }

            .vs-table--thead{
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text{
                        text-transform: uppercase;
                        font-weight: 600;

                    }
                }
                th.td-check{
                    padding: 0 15px !important;
                }
                tr{
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>


